
namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    export class VendorsDialog extends Serenity.EntityDialog<VendorsRow, any> {
        protected getFormKey() { return VendorsForm.formKey; }
        protected getIdProperty() { return VendorsRow.idProperty; }
        protected getLocalTextPrefix() { return VendorsRow.localTextPrefix; }
        protected getNameProperty() { return VendorsRow.nameProperty; }
        protected getService() { return VendorsService.baseUrl; }
        protected getDeletePermission() { return VendorsRow.deletePermission; }
        protected getInsertPermission() { return VendorsRow.insertPermission; }
        protected getUpdatePermission() { return VendorsRow.updatePermission; }

        protected form = new VendorsForm(this.idPrefix);

    }
}